import { observer } from 'mobx-react';
import React, { FC, useCallback, useEffect } from 'react';
import { TableOutlined } from '@ant-design/icons';

import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { i18n } from 'controls/designer/features/widgets/datasources/tile/localization';
import { AntInput } from 'controls/react/ant/antInput';
import { AntButton } from 'controls/react/ant/antButton';

import { DatasourceRowEditorProps } from './types';
import { DataSourceCategorySelector } from 'controls/designer/features/widgets/datasources/shared/components/data-source-category-selector/dataSourceCategorySelector';

export const DataSourceRowEditor: FC<DatasourceRowEditorProps> = observer(({ manager, disabled }) => {
	const closeEditor = React.useRef<() => void | undefined>();

	useEffect(() => {
		return () => closeEditor.current?.();
	}, []);

	const onEdit = useCallback(() => {
		if (disabled) return;

		const modalResult = openModal(
			{
				title: i18n('Select Datasource row'),
				width: 1000,
				height: 500,
				resizable: true,
				mask: false,
				positionType: ModalPosition.Mouse,
				okText: i18n('Update'),
				defaultFooterButtons: ['ok'],
			},
			<DataSourceCategorySelector manager={manager} />,
		);
		closeEditor.current = modalResult.close;
	}, [manager, manager.rulesConfiguration, disabled]);

	const value = manager.columnName ? `${manager.columnName} = ${manager.config.selection.rowKeyValue}` : undefined;

	return (
		<>
			<AntInput
				style={{ cursor: disabled ? undefined : 'pointer' }}
				readOnly={true}
				disabled={disabled}
				value={value}
				onClick={onEdit}
			/>
			<AntButton type={'text'} onClick={onEdit} disabled={disabled} icon={<TableOutlined />} />
		</>
	);
});
